export const invoiceTypesOptions: {name: string, value: string}[] = [
  {name: 'well-founded-error', value: 'R1'},
  {name: 'bankruptcy-proceedings', value: 'R2'},
  {name: 'bad-debt', value: 'R3'},
  {name: 'other', value: 'R4'},
];